/* eslint-disable @typescript-eslint/naming-convention */

import { extendTheme } from '@chakra-ui/react';

// Component style overrides
import Accordion from './components/accordion';
import Avatar from './components/avatar';
import Button from './components/button';
import Form from './components/form';
import Input from './components/input';
import Progress from './components/progess';
import Tabs from './components/tabs';
import Checkbox from './components/checkbox';
import Radio from './components/radio';
import Select from './components/select';

const overrides = {
  styles: {
    global: {
      'html, body': {
        scrollBehavior: 'smooth',
        fontFamily: 'Ubuntu',
      },
    },
  },
  fonts: {
    heading: 'Ubuntu',
    body: 'Ubuntu',
  },
  fontSizes: {
    h1: { base: '2.375rem', md: '2.625rem' },
    h2: { base: '1.75rem', md: '2rem' },
    h3: { base: '1.5rem', md: '1.625rem' },
    h4: '1.25rem',
    large: '1.125rem',
    medium: '1rem',
    small: '0.875rem',
  },
  colors: {
    brand: {
      red: { light: '#e2001a', dark: '#c61618' },
      black: '#221e1f',
      gray: '#939598',
      sand: '#e5e3df',
      green: '#21b417',
      yellow: '#f4c40f',
    },
  },
  shadows: {
    brand: {
      hover: '0 12px 14px 0 rgba(0, 0, 0, 0.33)',
    },
  },
  components: {
    Accordion,
    Button,
    Checkbox,
    Radio,
    Input,
    Form,
    Progress,
    Tabs,
    Avatar,
    Select,
  },
};

export default extendTheme(overrides);
